export default "__VITE_ASSET__c2b3bf2d__"